module.exports = __webpack_public_path__ + "img/football_for_the_goals.469934ff.png";